<script >
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  },
  stock: {
    type: Object,
    default: null
  },
  favoriteFolders: {
    type: Array,
    default: () => []
  },
  canUseFavorites: {
    type: Boolean,
    default: false
  },
  isMutating: {
    type: Boolean,
    default: false
  },
  error: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const isSelected = folder => Boolean(props.stock?.folderNames?.includes(folder.name));
  return {
    emit,
    isSelected
  };
};
export default __sfc_main;
</script>

<template>
    <Dialog
        :visible="visible"
        modal
        dismissable-mask
        close-on-escape
        mask-class="charting-mobile-favorite-mask"
        dialog-class="charting-mobile-favorite-dialog"
        :dialog-style="{ width: '100%' }"
        @update:visible="emit('update:visible', $event)"
    >
        <template #header>
            <div>
                <div class="charting-mobile-favorite-sheet__eyebrow">Favoritos</div>
                <div class="charting-mobile-favorite-sheet__title">Guardar {{ stock && stock.ticker }}</div>
            </div>
        </template>

        <div v-if="!canUseFavorites" class="charting-mobile-favorite-sheet__empty">Tu plan actual no permite gestionar favoritos.</div>
        <div v-else-if="!favoriteFolders.length" class="charting-mobile-favorite-sheet__empty">Todavía no tienes carpetas. Puedes crearlas desde Workspaces.</div>
        <div v-else class="charting-mobile-favorite-sheet__folders">
            <button
                v-for="folder in favoriteFolders"
                :key="folder.id"
                type="button"
                :class="{ 'is-selected': isSelected(folder) }"
                :disabled="isMutating"
                @click="emit('toggle-folder', folder.name)"
            >
                <span class="charting-workspace-folder-dot" :style="{ backgroundColor: folder.color }"></span>
                <span>{{ folder.label }}</span>
                <i :class="isSelected(folder) ? 'pi pi-check-circle' : 'pi pi-circle'"></i>
            </button>
        </div>
        <div v-if="error" class="charting-mobile-favorite-sheet__error">{{ error }}</div>
    </Dialog>
</template>

<style scoped>
.charting-mobile-favorite-sheet__eyebrow { color: var(--p-text-muted-color); font-size: 0.68rem; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; }
.charting-mobile-favorite-sheet__title { margin-top: 0.2rem; font-size: 1.05rem; font-weight: 800; }
.charting-mobile-favorite-sheet__folders { display: flex; flex-direction: column; gap: 0.45rem; }
.charting-mobile-favorite-sheet__folders button { display: grid; grid-template-columns: auto minmax(0, 1fr) auto; align-items: center; gap: 0.7rem; width: 100%; border: 1px solid var(--charting-b-border-color); border-radius: 0.9rem; background: var(--charting-b-panel-bg-strong); padding: 0.8rem; color: var(--p-text-color); text-align: left; cursor: pointer; }
.charting-mobile-favorite-sheet__folders button.is-selected { border-color: var(--brand-primary); background: color-mix(in srgb, var(--brand-primary), transparent 88%); }
.charting-mobile-favorite-sheet__folders button:disabled { cursor: wait; opacity: 0.6; }
.charting-mobile-favorite-sheet__empty { border: 1px dashed var(--charting-b-border-color); border-radius: 0.9rem; padding: 1rem; color: var(--p-text-muted-color); }
.charting-mobile-favorite-sheet__error { margin-top: 0.7rem; color: var(--p-red-500, #ef4444); font-size: 0.78rem; }
</style>

<style>
@media (max-width: 699px) {
    .p-dialog-mask.charting-mobile-favorite-mask { top: var(--modern-shell-header-height, 62px); align-items: flex-end; padding: 0; }
    .p-dialog.charting-mobile-favorite-dialog { width: 100% !important; max-width: none; max-height: min(72dvh, 38rem); border-radius: 1.35rem 1.35rem 0 0; padding-bottom: env(safe-area-inset-bottom); }
}
</style>
